import parse from 'url-parse'

function configFromParams (url = window.location.href) {
  if (!url) {
    return {}
  }
  const query = parse(url, true).query

  let scoreTarget = isFinite(query.st) ? query.st : undefined
  let topicsExcluded = query.te ? JSON.parse(query.te) : []

  try {
    // hack to pass score target and topic exclusions via the same query string param
    const hack = JSON.parse(query.st)
    scoreTarget = isFinite(hack.st) ? hack.st : scoreTarget
    topicsExcluded = Array.isArray(hack.te) ? hack.te : topicsExcluded
  } catch (err) {
    // this is not unexpected, query.st may or may not be json
  }

  return {
    file: query.file,
    testMode: query.test_mode === 'true',
    fromFqTool: query.from_fq_tool === 'true',
    argaServer: query.ARGA_server,
    // [arga|?]
    reportingMode: query.reportingMode,
    // [student|instructor]
    isInstructorView: query.view === 'instructor' || query.view === 'instructor_restricted',
    isRestrictedInstructor: query.view === 'instructor_restricted',
    autoStartTrends: query.autoStartTrends === '1',
    enrollmentId: query.enrollmentid,
    approot: query.approot,
    extEnrollmentId: query.ext_enrollmentid,
    itemId: query.itemid,
    startTime: query.startTime,
    dueDate: query.dueDate,
    scoreTarget,
    topicsExcluded,
    disableEbook: query.disable_ebook === 'true',
    disableLinks: query.disable_links === 'true',
    questionIndex: query.qid,
    // [normal|by_number_of_questions]
    topicSelection: query.topic_selection ? query.topic_selection : 'normal',
    noPsp: query.no_psp === 'true', // psp = personalized study plan
    skipStartPage: query.hide_start === 'true',
    // obsolete, report is always shown on instructor page
    showReport: query.show_report === 'true',
    // obsolete, full report is always shown on instructor page
    reportType: query.report_type, // [showAll|?]
    // (may be obsolete): if standalone, call parent.LearningCurve.closeParentDialog() when pause button is clicked
    standalone: query.lc_type === 'standalone', // [standalone|?]
    // simulateRetake for LC Classic Instructor view and LCRP Student Retake UX
    simulateData: query.simulateData,
    forceClassicPreview: query.forceClassicPreview,
    // obsolete, the to-do list was unusable and not fully implemented in legacy LC
    showTodoList: query.todo,
    forceLpEnv: query.forceLpEnv,
    previewMode: query.previewMode, // lcrp only
    // Demo Bubbles ARE NOT IMPLEMENTED:
    // see https://macmillanlearning.atlassian.net/browse/MLLC-251
    showDemoBubbles: query.demo_bubbles === 'true',
    user_id: query.user_id,
    demo: query.demo,
    returnUrl: query.return_url,
    courseId: query.course_id,
    headerStyle: query.header_style || 'default',
    lmsId: query.lms_id,
    isAchieve: query.is_achieve === 'true'
  }
}

export default configFromParams
